import React , { useState } from 'react'; 
import { Button } from 'primereact/button';

export default function MoveButton( { clicked , count }) {
    const [isClicked, setIsClicked] = useState(false);  

    function onClicked() {
        setIsClicked(true);
        clicked();
    }

    return (
        <div className="card flex justify-content-center">
            <Button enabled={!isClicked} onClick={() => onClicked()} icon="pi pi-check" label={`Mover a produccion(${count})`} />
        </div>
    )
}